import ExcelJS from 'exceljs';

export default class TarifasExcelExporter {

  static async exportReporteTarifas(data, title = "Reporte Tarifas") {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tarifas");

    // Título general: fusionar celdas de A1 a E1
    worksheet.mergeCells('A1:E1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = title;
    titleCell.font = { bold: true, size: 18 };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB0C4DE' } };
    // Fila vacía debajo del título
    worksheet.addRow([]);

    // Fila de encabezados fijos (similar a <thead>)
    const colHeaders = ["Tipo de juego", "Horario", "Nombre de Horario", "Tarifario", "Precio"];
    const headerRow = worksheet.addRow(colHeaders);
    headerRow.font = { bold: true, size: 12 };
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    headerRow.eachCell(cell => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFADD8E6' } };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Recorrer la data y agregar filas según el tipo (header o normal)
    data.forEach((tarifa) => {
      if (tarifa.header === true) {
        // Agregar fila de grupo con celdas fusionadas
        const groupRow = worksheet.addRow([]);
        // Fusionar columnas: A y B; D y E (en un total de 5 columnas: A,B,C,D,E)
        worksheet.mergeCells(`A${groupRow.number}:B${groupRow.number}`);
        worksheet.mergeCells(`D${groupRow.number}:E${groupRow.number}`);
        // Asignar valores:
        groupRow.getCell(1).value = "Categoría: " + (tarifa.nombreCategoria || "");
        groupRow.getCell(3).value = "Departamento: " + (tarifa.nombreDepartamento || "");
        groupRow.getCell(4).value = "Temporada: " + (tarifa.temporadaCompleta || "");
        // Formatear la fila de grupo
        groupRow.font = { bold: true, size: 12 };
        groupRow.alignment = { horizontal: 'center', vertical: 'middle' };
        groupRow.eachCell(cell => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; // Gris
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      } else {
        // Fila normal con datos
        const row = worksheet.addRow([
          tarifa.tipoJuego,
          tarifa.horario,
          tarifa.nombreHorario,
          tarifa.nombreTarifario,
          tarifa.precio
        ]);
        row.alignment = { horizontal: 'left', vertical: 'middle' };
        row.eachCell(cell => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      }
    });

    // Autoajuste del ancho de columnas según el contenido
    worksheet.columns.forEach(column => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, cell => {
        const cellText = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellText.length);
      });
      column.width = maxLength + 2;
    });

    return workbook.xlsx.writeBuffer();
  }
}
